/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from "react";
// import { Provider } from "react-redux";
import { BrowserRouter, HashRouter } from "react-router-dom";
// import { PersistGate } from "redux-persist/integration/react";
import { Routes2 } from "../app/Routes2";
import { I18nProvider } from "../_metronic/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_metronic/layout";
import ContextApp from "../core/contexts/context.app";
import ProviderApp from "../core/providers/provider.app";
import { ToastContainer } from "react-toastify";
// import "./main.css"

export default function App({ store, persistor, basename }) {
  return (
    <>
      {/* <Provider store={store}> */}
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      {/* <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}> */}
      {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
      <ProviderApp>
        <ContextApp.Consumer>
          {(context) => {
            return (
              <React.Suspense fallback={<LayoutSplashScreen />}>
                {/* Override `basename` (e.g: `homepage` in `package.json`) */}
                <BrowserRouter basename={basename}>
                  {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
                  <MaterialThemeProvider>
                    {/* Provide `react-intl` context synchronized with Redux state.  */}
                    <I18nProvider>
                      <ToastContainer rtl={true} />
                      {/* Render routes with provided `Layout`. */}
                      {/* <HashRouter> */}

                      <Routes2 />
                      {/* </HashRouter>  */}
                    </I18nProvider>
                  </MaterialThemeProvider>
                </BrowserRouter>
              </React.Suspense>
            );
          }
          }
        </ContextApp.Consumer>
      </ProviderApp>
      {/* </PersistGate> */}
      {/* </Provider> */}
    </>
  );
}
